var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#134A81",
    d: "M3.106 6.359l4.101-4.102A1 1 0 005.793.843l-4.95 4.95a1 1 0 000 1.414l4.95 4.95a1 1 0 001.414-1.414L3.106 6.64a.2.2 0 010-.282z"
  })));
}
export default SvgArrowRightBlue;